export const en: Record<string, string> = {
};

export const tl: Record<string, string> = {
  "detail.service.about": "Tungkol sa serbisyong ito",
  "detail.service.included": "Kasama rito",
  "detail.service.reviews": "Mga Review at Rating",
  "detail.service.noReviews": "Wala pang review.",
  "detail.service.noFeedback": "Wala pang nakasulat na feedback.",
  "detail.service.area": "Lugar ng Serbisyo",
  "detail.service.startingAt": "Nagsisimula sa",
  "detail.service.price": "Presyo",
  "detail.service.finalPrice": "Nakadepende ang huling presyo sa saklaw ng proyekto, mga materyales, at lokasyon.",
  "detail.service.requestQuote": "Humingi ng Presyo",
  "detail.service.messageProvider": "I-message ang Provider",
  "detail.service.aboutProvider": "Tungkol sa Provider",
  "detail.service.servicesListed": "Mga Serbisyo",
  "detail.service.escrowHire": "Proteksiyon ng escrow at yugto kapag nag-hire",
  "detail.service.verifiedProvider": "Beripikadong provider",
  "detail.service.identityBusiness": "Beripikado ang pagkakakilanlan at negosyo",
  "detail.service.securePayments": "Ligtas na mga bayad",
  "detail.service.escrowProtection": "Proteksiyon ng escrow at mga yugto",
  "detail.service.transparentReviews": "Malinaw na mga review",
  "detail.service.pastFeedback": "Feedback mula sa mga dating kliyente",
  "detail.service.from": "Mula sa",
  "detail.service.quote": "Presyo ayon sa sipi",
  "detail.service.noSimilar": "Wala pang katulad na serbisyo.",
  "detail.job.description": "Paglalarawan ng Trabaho",
  "detail.job.skillsResponsibilities": "Mga Kasanayan at Responsibilidad",
  "detail.job.noRequirements": "Wala pang detalyadong kinakailangan. Tanungin ang employer tungkol sa trabaho bago mag-apply.",
  "detail.job.benefits": "Mga Benepisyo at Perk",
  "detail.job.noBenefits": "Wala pang nakalistang benepisyo para sa trabahong ito. Tanungin ang employer para sa detalye.",
  "detail.job.aboutEmployer": "Tungkol sa Employer",
  "detail.job.viewProfile": "Tingnan ang profile",
  "detail.job.offeredSalary": "Iniaalok na sahod",
  "detail.job.applicants": "mga aplikante",
  "detail.job.posted": "Naipost",
  "detail.job.memberSince": "Miyembro mula noong",
  "detail.job.similarJobs": "Mga Katulad na Trabaho",
  "detail.job.noSimilar": "Wala pang katulad na trabaho sa ngayon.",
  "detail.company.businessArea": "Lugar ng Negosyo",
  "detail.company.about": "Tungkol sa",
  "detail.company.information": "Impormasyon ng Kompanya",
  "detail.company.industry": "Industriya",
  "detail.company.businessStatus": "Katayuan ng negosyo",
  "detail.company.productsServices": "Mga Produkto at Serbisyo",
  "detail.company.areasExpertise": "Mga Larangan ng Kadalubhasaan",
  "detail.company.similarCompanies": "Mga Katulad na Kompanya",
  "detail.project.bidSummary": "Buod ng Bid",
  "detail.project.bidsReceived": "Mga Natanggap na Bid",
  "detail.project.openUntil": "Bukas hanggang",
  "detail.project.closedOn": "Isinara noong",
  "detail.project.estimatedBudget": "Tinatayang Badyet",
  "detail.project.targetCompletion": "Target na petsa ng pagkumpleto",
  "detail.project.aboutClient": "Tungkol sa Kliyente",
  "detail.project.projectsPosted": "Mga Naipost na Proyekto",
  "detail.project.projectsAwarded": "Mga Iginawad na Proyekto",
  "detail.project.identityVerified": "Beripikado ang Pagkakakilanlan",
  "detail.project.sealedProcess": "Proseso ng Selyadong Bid",
  "detail.rfq.summary": "Buod ng RFQ",
  "detail.rfq.aboutRequester": "Tungkol sa Humihiling",
  "detail.rfq.requester": "Humihiling ng RFQ",
  "detail.rfq.rfqsPosted": "Mga Naipost na RFQ",
  "detail.rfq.rfqsAwarded": "Mga Iginawad na RFQ",
  "detail.profile.employer": "Employer",
  "detail.profile.company": "Kumpanya",
  "detail.profile.individual": "Indibidwal",
  "detail.profile.jobsPosted": "Mga Naipost na Trabaho",
  "detail.profile.peopleHired": "Mga Natanggap na Manggagawa",
  "detail.profile.reviewsUnavailable": "Hindi available ang mga review",
  "detail.rfq.status": "Katayuan",
  "detail.rfq.lineItems": "Mga item",
  "detail.rfq.quotesReceived": "Mga Natanggap na Sipi",
  "detail.rfq.closes": "Magsasara sa",
  "detail.rfq.requestedItems": "Mga Hiniling na Item",
  "detail.rfq.suggestedOrganizations": "Mga Iminungkahing Organisasyon",
  "detail.rfq.submitQuote": "Isumite ang Iyong Sipi",
  "detail.item.marketplace": "Marketplace",
  "detail.item.description": "Paglalarawan",
  "detail.item.itemDetails": "Detalye ng Item",
  "detail.item.features": "Mga Katangian",
  "detail.item.forRent": "Pauupahan",
  "detail.item.forSale": "Ibinebenta",
  "detail.item.condition": "Kondisyon",
  "detail.item.brand": "Brand",
  "detail.item.model": "Modelo",
  "detail.item.storage": "Imbakan",
  "detail.item.color": "Kulay",
  "detail.item.category": "Kategorya",
  "detail.item.noFeatures": "Walang nakalistang katangian. Tanungin ang nagbebenta para sa detalye.",
  "detail.item.notProvided": "Hindi ibinigay",
  "detail.item.aboutRental": "Tungkol sa paupahang ito",
  "detail.item.kind.material": "Materyal / Suplay",
  "detail.item.kind.equipment": "Kagamitan / Kasangkapan",
  "detail.item.kind.property": "Ari-arian",
  "detail.item.kind.vehicle_transport": "Sasakyan / Transportasyon",
  "detail.item.kind.heavy_machinery": "Mabibigat na Makina",
  "detail.item.kind.electrical": "Elektrikal",
  "detail.item.kind.plumbing_sanitary": "Tubero / Sanitaryo",
  "detail.item.kind.business": "Negosyong Ibinebenta",
  "detail.item.kind.safety_ppe": "Kaligtasan / PPE",
  "detail.item.kind.formwork_scaffold": "Formwork / Scaffolding",
  "detail.item.kind.fixtures_finishes": "Fixtures / Finishes",
  "detail.item.kind.site_facilities": "Pasilidad ng Opisina / Lugar ng Trabaho",
  "detail.item.kind.surplus_salvaged": "Sobrang / Narekober na Materyales",
  "detail.item.categoryValue.Gadget": "Gadyet",
  "detail.item.used": "Gamit na",
  "detail.item.new": "Bago",
  "detail.item.posted": "Na-post",
  "detail.item.viewsUnavailable": "Hindi available ang bilang ng pagtingin",
  "detail.item.favoritesUnavailable": "Hindi available ang bilang ng paborito",
  "detail.item.inclusions": "Mga kasama:",
  "detail.item.included": "Kasama:",
  "detail.item.reasonForSelling": "Dahilan ng pagbebenta:",
  "detail.item.sellerReviews": "Mga review ng nagbebenta",
  "detail.item.loadingReviews": "Nilo-load ang mga review…",
  "detail.item.noSellerReviews": "Wala pang review ang nagbebentang ito.",
  "detail.item.listingSummary": "Buod ng Listahan",
  "detail.item.aboutSeller": "Tungkol sa Nagbebenta",
  "detail.item.aboutOwner": "Tungkol sa May-ari",
  "detail.item.manageListing": "Pamahalaan ang listahan",
  "detail.item.ownListingSummary": "Ito ang iyong listahan.",
  "detail.item.sellerInformation": "Impormasyon ng nagbebenta",
  "detail.item.ownerInformation": "Impormasyon ng may-ari",
  "detail.item.viewProfile": "Tingnan ang profile →",
  "detail.item.member": "Miyembro",
  "detail.item.noReviews": "Wala pang review",
  "detail.item.reviews": "mga review",
  "detail.item.locationUnavailable": "Hindi ibinigay ang lokasyon",
  "detail.item.memberSince": "Miyembro mula noong",
  "detail.item.memberSinceUnavailable": "Hindi available ang petsa ng pagiging miyembro",
  "detail.item.listings": "Mga listahan",
  "detail.item.sold": "Nabenta",
  "detail.item.rentals": "Mga paupahan",
  "detail.item.responseRate": "Antas ng pagtugon",
  "detail.item.followSeller": "Sundan ang Nagbebenta",
  "detail.item.followUnavailable": "Hindi pa available ang pagsunod sa nagbebenta",
  "detail.item.price": "Presyo",
  "detail.item.rentalPrice": "Presyo ng paupahan",
  "detail.item.outOfStock": "Wala nang stock",
  "detail.item.listingUnavailable": "Hindi available ang listahan",
  "detail.item.availableForRent": "Puwedeng paupahan",
  "detail.item.available": "available",
  "detail.item.messageSeller": "I-message ang nagbebenta",
  "detail.item.messageOwner": "I-message ang may-ari",
  "detail.item.escrowNote": "Hahawakan sa escrow ang bayad hanggang makumpirma ang pagtanggap.",
  "detail.item.meetupDelivery": "Pagkikita / Paghahatid",
  "detail.item.pickupReturn": "Pagkuha / Pagbalik",
  "detail.item.itemLocation": "Lokasyon ng item",
  "detail.item.location": "Lokasyon",
  "detail.item.handoverOptions": "Mga paraan ng pag-abot",
  "detail.item.arrangeWithSeller": "Makipag-ayos sa nagbebenta",
  "detail.item.handover.pickup": "Pagkuha",
  "detail.item.handover.meetup": "Pagkikita",
  "detail.item.handover.delivery_arrangement": "Napagkasunduang paghahatid",
  "detail.item.operatingStatus": "Katayuan ng operasyon",
  "detail.item.operatingStatus.operating": "Bukas at nagpapatakbo",
  "detail.item.operatingStatus.temporarily_closed": "Pansamantalang sarado",
  "detail.item.operatingStatus.closed": "Sarado",
  "detail.item.operatingStatus.not_yet_operating": "Hindi pa nagpapatakbo",
  "detail.item.deliveryOptions": "Mga paraan ng paghahatid",
  "detail.item.pickupOptions": "Mga paraan ng pagkuha",
  "detail.item.meetupOptions": "Mga paraan ng pagkikita",
  "detail.item.returnOptions": "Mga paraan ng pagbalik",
  "detail.item.paymentMethods": "Mga paraan ng pagbabayad",
  "detail.item.walletBalance": "Balanse sa wallet",
  "detail.item.paymentMethodsNote": "Magdagdag ng pondo sa wallet gamit ang mga available na paraan bago mag-checkout. Walang direktang pagpili ng card, GCash, Maya, o bank transfer sa pag-checkout ng item na ito.",
  "detail.item.day": "araw",
  "detail.item.days": "araw",
  "detail.item.asking": "hinihinging presyo",
  "detail.item.orderPlaced": "Naipasa ang order!",
  "detail.item.escrowPlaced": "ay hahawakan sa escrow hanggang makumpirma mo ang pagtanggap.",
  "detail.item.myOrders": "Aking mga Order",
  "detail.item.keepBrowsing": "Mag-browse pa",
  "detail.item.ownListing": "Listahan mo ito. Pamahalaan ito sa iyong",
  "detail.item.dashboard": "dashboard",
  "detail.item.noLongerAvailable": "Hindi na available ang listahang ito.",
  "detail.item.askBusiness": "Quotation sa pagbebenta ng negosyo",
  "detail.item.inquiryHint": "Humingi ng detalye at talakayin ang bentahan sa nagbebenta.",
  "detail.item.inquireBusiness": "Magtanong tungkol sa negosyong ito",
  "detail.item.orderDetails": "Detalye ng order",
  "detail.item.pickupDate": "Petsa ng pagkuha",
  "detail.item.returnDate": "Petsa ng pagbalik",
  "detail.item.rentalDateHint": "Kinakalkula ng mga petsa ang haba ng paupahan. Kumpirmahin sa may-ari ang pag-abot ng item. Hindi ibinigay ang refundable na deposito.",
  "detail.item.invalidDates": "Pumili ng petsa ng pagkuha at pagbalik na may pagitan na 1 hanggang 3,650 araw.",
  "detail.item.quantity": "Dami",
  "detail.item.decreaseQuantity": "Bawasan ang dami",
  "detail.item.increaseQuantity": "Dagdagan ang dami",
  "detail.item.total": "Kabuuan",
  "detail.item.rentNow": "Paupahan ngayon",
  "detail.item.signInFirst": "Hihilingin munang mag-sign in ka.",
  "detail.item.activeListings": "Mga aktibong listahan",
  "detail.item.items": "mga item",
  "detail.item.basedOnSellerReviews": "Batay sa {count} review ng nagbebenta",
  "detail.item.askingPrice": "Hinihinging presyo",
  "detail.item.inquire": "Humiling ng quotation",
  "detail.item.noDescriptionSeller": "Wala pang idinagdag na paglalarawan ang nagbebenta.",
  "detail.item.noDescriptionOwner": "Wala pang idinagdag na paglalarawan ang may-ari.",
  "detail.item.loading": "Nilo-load ang item…",
  "detail.item.notFound": "Hindi makita ang item",
  "detail.item.browse": "Mag-browse ng Materyales",
  "detail.item.pickupAgreement": "Pagkasunduan sa may-ari ang pagkuha, pagbalik, at pagsusuri ng kundisyon bago mag-book.",
  "detail.item.rentalTerms": "Mga tuntunin ng paupahan",
  "detail.item.rate": "Singil",
  "detail.item.refundableDeposit": "Ibabalik na deposito",
  "detail.item.minimumRental": "Pinakamaikling paupahan",
  "detail.item.returnCondition": "Kundisyon sa pagbalik",
  "detail.item.confirmWithOwner": "Kumpirmahin sa may-ari",
  "detail.item.contactBusiness": "Makipag-ugnayan sa nagbebenta upang talakayin ang negosyong ito.",
  "detail.item.payment": "Pagbabayad",
  "detail.item.walletPaid": "Binayaran mula sa balanse ng wallet mo",
  "detail.item.checkoutFeedback": "Kumusta ang pag-checkout?",
  "detail.item.availableOnly": "{count} lamang ang available.",
  "detail.item.orderFailed": "Hindi mailagay ang order.",
  "detail.item.rentalDateHintFull": "Kinakalkula ng mga petsa ang haba ng paupahan. Kumpirmahin sa may-ari ang eksaktong oras ng pag-abot ng item. Hindi ibinigay ang refundable na deposito.",
  "detail.company.companies": "Mga Kompanya",
  "detail.company.servicesProducts": "Mga serbisyo at produkto",
  "detail.company.overview": "Pangkalahatang-ideya",
  "detail.company.services": "Mga Serbisyo",
  "detail.company.products": "Mga Produkto",
  "detail.company.reviews": "Mga Review",
  "detail.company.ratingsBasis": "Batay ang mga rating sa mga review para sa kompanyang ito.",
  "detail.company.serves": "Nagbibigay-serbisyo sa",
  "detail.company.editBusiness": "I-edit ang profile ng negosyo",
  "detail.company.contact": "Makipag-ugnayan",
  "detail.company.requestQuote": "Humingi ng Presyo",
  "detail.company.viewProfile": "Tingnan ang profile",
  "detail.company.startingAt": "Nagsisimula sa",
  "detail.company.inquire": "Magtanong",
  "detail.company.productsEquipment": "Mga Produkto at Kagamitan",
  "detail.company.newRating": "Bago",
  "detail.company.title": "Kompanya",
  "detail.company.reviewsRatings": "Mga Review at Rating",
  "detail.company.similar": "Mga Katulad na Kompanya",
  "detail.rfq.awarded": "Iginawad",
  "detail.rfq.open": "Bukas",
  "detail.rfq.openQuotes": "Bukas para sa mga Sipi",
  "detail.rfq.category": "Kategorya",
  "detail.rfq.due": "Takdang petsa",
  "detail.rfq.postedBy": "Nag-post si",
  "detail.rfq.messageBuyer": "I-message ang mamimili",
  "detail.rfq.item": "Item",
  "detail.rfq.quantity": "Dami",
  "detail.rfq.unit": "Yunit",
  "detail.rfq.terms": "Mga tuntunin",
  "detail.rfq.companySupplier": "Kompanya / Supplier",
  "detail.rfq.yourCompany": "Pangalan ng iyong kompanya",
  "detail.rfq.validity": "Bisa",
  "detail.rfq.notes": "Mga tala",
  "detail.rfq.quoteTotal": "Kabuuang sipi",
  "detail.rfq.submitQuoteShort": "Magsumite ng Sipi",
  "detail.rfq.unitPrice": "presyo bawat yunit",
  "detail.rfq.validityHint": "Pumili o mag-type, hal. 30 araw",
  "detail.rfq.notesHint": "Kasama, paghahatid, warranty…",
  "detail.item.buyNow": "Bilhin ngayon",
};
